// PorterIQ Custom Table Head Styles

export default {
  styleOverrides: {
    root: {
      backgroundColor: "transparent",
    },
  },
};
